import type { Dayjs } from 'dayjs';

export interface PositionContinuityRow {
    local_id: string;
    to_delete: boolean;
    work_position_id: number;
    start_date: Dayjs | null;
    end_date: Dayjs | null;
}

type DatedPositionContinuityRow = PositionContinuityRow & {
    start_date: Dayjs;
    end_date: Dayjs;
};

export const getRepeatedPositionRowIds = (rows: readonly PositionContinuityRow[]): string[] => {
    const datedActiveRows = rows
        .filter((row): row is DatedPositionContinuityRow => !row.to_delete && row.start_date?.isValid() === true && row.end_date?.isValid() === true)
        .sort((first, second) => first.start_date.diff(second.start_date));

    const repeatedRowIds: string[] = [];

    for (let index = 1; index < datedActiveRows.length; index++) {
        const previous = datedActiveRows[index - 1];
        const current = datedActiveRows[index];

        if (current.work_position_id === previous.work_position_id && current.start_date.isSame(previous.end_date.add(1, 'day'), 'day')) {
            repeatedRowIds.push(current.local_id);
        }
    }

    return repeatedRowIds;
};
